import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { isArrayOfObjects } from "../detect";
import { humanizeKey } from "../humanize";
import { PRIORITY, type RenderContext, type ValueRenderer } from "../types";
import { RegistryValue } from "./RegistryValue";

/** Union of keys across all rows, in first-seen order. */
function columnsOf(rows: Record<string, unknown>[]): string[] {
  const cols: string[] = [];
  for (const row of rows) {
    for (const k of Object.keys(row)) {
      if (!cols.includes(k)) cols.push(k);
    }
  }
  return cols;
}

const MAX_ROWS = 100;

export const TableRenderer: ValueRenderer = {
  id: "table",
  match: value => (isArrayOfObjects(value) ? { priority: PRIORITY.STRUCTURAL, confidence: "high" } : null),
  Component: ({ value, ctx }) => {
    const rows = value as Record<string, unknown>[];
    const cols = columnsOf(rows);
    const shown = rows.slice(0, MAX_ROWS);
    return (
      <div>
        <Table className="text-xs">
          <TableHeader>
            <TableRow>
              {cols.map(c => (
                <TableHead key={c}>{humanizeKey(c)}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {shown.map((row, rowIdx) => (
              <TableRow key={rowIdx}>
                {cols.map(c => {
                  const childCtx: RenderContext = {
                    ...ctx,
                    key: c,
                    parent: row,
                    path: [...ctx.path, rowIdx, c],
                    depth: ctx.depth + 1,
                  };
                  return (
                    <TableCell key={c} className="align-top">
                      {c in row ? <RegistryValue value={row[c]} ctx={childCtx} /> : null}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {rows.length > MAX_ROWS && (
          <p className="text-ds-text-muted mt-1 text-xs">
            Showing {MAX_ROWS} of {rows.length} rows — switch to JSON mode to see all.
          </p>
        )}
      </div>
    );
  },
};
